import PageFlipIcon from '@shared/Icons/PageFlipIcon';
import React from 'react';
import { useTemplatesViewModel } from '@viewModels/TemplatesViewModel/TemplatesViewModel';
import styles from './TemplateInfoHeader.module.css';

interface TemplateInfoHeaderProps {
    isTitleRequired: boolean;
}

export const TemplateInfoHeader: React.FC<TemplateInfoHeaderProps> = ({
    isTitleRequired,
}) => {
    const { currentTemplate } = useTemplatesViewModel();

    const categories = currentTemplate?.categories
        ? currentTemplate?.categories.map(c => c.category).join(', ')
        : [];

    return (
        <div className={styles.blogCategories}>
            <div className={styles.left}>
                <p>Category: {categories}</p>
                <PageFlipIcon
                    fill={'white'}
                    className={styles.icon}
                    stroke={'var(--color-interactive-primary)'}
                />
            </div>
            {isTitleRequired && (
                <p className={styles.blogNameTitle}>{currentTemplate?.title}</p>
            )}
        </div>
    );
};
